import { createAction } from 'redux-actions';

export const GET_MY_REFERRED_LIST = 'GET_MY_REFERRED_LIST';
export const getMyReferredList = createAction(GET_MY_REFERRED_LIST);

export const GET_TOP_REFERRAL_LIST = 'GET_TOP_REFERRAL_LIST';
export const getTopReferralList = createAction(GET_TOP_REFERRAL_LIST);

export const GET_NOTIFICATIONS_LIST = 'GET_NOTIFICATIONS_LIST';
export const getNotificationsList = createAction(GET_NOTIFICATIONS_LIST);

export const GET_NOTIFICATION_DETAIL = 'GET_NOTIFICATION_DETAIL';
export const getNotificationDetail = createAction(GET_NOTIFICATION_DETAIL);

export const UPLOAD_PAN_IMAGE = 'UPLOAD_PAN_IMAGE';
export const uploadPANImage = createAction(UPLOAD_PAN_IMAGE);

export const UPLOAD_BANK_IMAGE = 'UPLOAD_BANK_IMAGE';
export const uploadBankImage = createAction(UPLOAD_BANK_IMAGE);

export const GET_BANNERS = 'GET_BANNERS';
export const getBanners = createAction(GET_BANNERS);

export const SET_BANNERS = 'SET_BANNERS';
export const setBanners = createAction(SET_BANNERS);
